import { Controller } from "stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
  static targets = ['modalHour', 'container'];

  connect() {}

  openModal() {
    $(this.modalHourTarget).modal('show');
  }

  remove(ev) {
    ev.preventDefault();

    let $row = ev.currentTarget.closest('.work-period-time-row'),
      inputName = $row.dataset.objectName;
    this.askConfirmation().then((result) => {
      if (result.value) {
        !!$row.dataset.objectId && this.containerTarget.insertAdjacentHTML('beforeend', `
          <input type="hidden" name="${inputName}[id]" value="${$row.dataset.objectId}" />
          <input type="hidden" name="${inputName}[_destroy]" value="1" />
        `);
        $row.remove();
        this.amountValue -= 1;
        return;
      }
    })
  }

  askConfirmation() {
    return Swal.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      html: "Deseja realmente <b>remover</b> esse período?",
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }


  addHour() {

  }
}